import React from 'react';
import { Close } from '@mui/icons-material';
import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import { type SvgIconProps } from '@mui/material/SvgIcon';
import translate from '@/lib/intl/translate';

function CloseButton({
  iconProps = {},
  label = translate('CLOSE'),
  ...rest
}: IconButtonProps & { iconProps?: SvgIconProps; label?: string }) {
  return (
    <IconButton aria-label={label} size="large" {...rest}>
      <Close className="text-text-primary" {...iconProps} />
    </IconButton>
  );
}

export default CloseButton;
